import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { LoaderService } from '../components/loader/loader.service';
import { AlertService } from '../services/alert.service';
import { catchError, throwError } from 'rxjs';
import { typedKeys } from '../functions/functions';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const _alertService = inject(AlertService);
  const _authService = inject(AuthService);
  const _loaderService = inject(LoaderService);

  if (!req.url.includes('digitaloceanspaces')) {
    const jwtToken = _authService.getToken;
    if (jwtToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
    }
  }

  return next(req).pipe(
    catchError((err) => {
      _loaderService.reset();
      if (
        err instanceof HttpErrorResponse &&
        err.error instanceof Blob &&
        (err.error.type === 'application/json' ||
          err.error.type === 'application/problem+json') &&
        [400, 401, 404, 500].includes(err.status)
      ) {
        // When request of type Blob, the error is also in Blob instead of object of the json data
        return new Promise<any>((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = (e: Event) => {
            try {
              const errorResponse = JSON.parse((<any>e.target).result);
              if (errorResponse.exception != undefined) {
                _alertService.addFailedMsg(errorResponse.exception);
              } else if(errorResponse.detail != undefined) {
                _alertService.addFailedMsg(errorResponse.detail);
              }
              else {
                _alertService.addFailedMsg(errorResponse.errors[0].message);
              }
              reject(
                new HttpErrorResponse({
                  error: errorResponse,
                  headers: err.headers,
                  status: err.status,
                  statusText: err.statusText,
                  url: err.url!,
                }),
              );
            } catch (e) {
              reject(err);
            }
          };
          reader.onerror = () => {
            reject(err);
          };
          reader.readAsText(err.error);
        });
      }
      return throwError(() => err);
    }),
  );
};
